module.exports = __webpack_public_path__ + "img/bg_intro_2_8.758fe6be.png";